import type { AiInsight } from '../types/ai'

export const dailyBriefSets: AiInsight[][] = [
  [
    {
      id: 'ai-1',
      label: 'Two gates will miss their review dates without intervention',
      detail:
        'Asian Games 2034 (Readiness) and COP38 (Plan & Build) both carry outstanding mandatory artefacts with under 60 days to review. Workforce readiness and the procurement certificate are the binding constraints.',
      confidence: 91,
      tone: 'risk'
    },
    {
      id: 'ai-2',
      label: 'Assessment is the pipeline bottleneck this month',
      detail:
        'Three records sit at Assessment with a mean 22 days in stage. Two are held on co-funding below the Mega threshold — the same condition that triggered 34 recommendations this year.',
      confidence: 87,
      tone: 'watch'
    },
    {
      id: 'ai-3',
      label: 'Outreach delivery is 8% ahead of guarantee overall',
      detail:
        'Across three live campaigns, 19.8M of a combined 27.2M impression guarantee is delivered with 46% of the windows remaining. Two single-channel laggards are recoverable by reallocation.',
      confidence: 84,
      tone: 'positive'
    }
  ],
  [
    {
      id: 'ai-4',
      label: 'FIFA 2038 bid clears its gate if the tax guarantee lands in August',
      detail:
        'Requirement coverage is one mandatory item from the 85% threshold. Escalated guarantees historically clear drafting in 3 weeks, leaving a 4-week buffer before the submission window closes.',
      confidence: 89,
      tone: 'watch'
    },
    {
      id: 'ai-5',
      label: 'Expo 2035 approval is exposed to a single sign-off',
      detail:
        'Four of five mandatory stakeholder sign-offs are captured. Only Ministry of Energy & Infrastructure remains, pending utilities capacity confirmation for the innovation district.',
      confidence: 93,
      tone: 'watch'
    },
    {
      id: 'ai-6',
      label: 'Entity capability is the strongest predictor of gate slippage',
      detail:
        'Across 41 closed records, entities with no prior event above AED 50M slipped at least one gate in 78% of cases. Two live records match that profile.',
      confidence: 81,
      tone: 'risk'
    }
  ]
]
